export default __webpack_public_path__ + "static/bench-8258c3cc466ee7c8bebc5bd89a776efa.png";